import api from './api';

const projectTemplateMasterService = {
  // Get all project template masters with pagination and filters
  getAllProjectTemplateMasters: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.search) queryParams.append('search', params.search);
      if (params.status) queryParams.append('status', params.status);
      if (params.category) queryParams.append('category', params.category);
      if (params.type) queryParams.append('type', params.type);
      
      const response = await api.get(`/project-template-masters?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching project template masters:', error);
      throw error;
    }
  },

  // Get project template master by ID
  getProjectTemplateMasterById: async (id) => {
    try {
      const response = await api.get(`/project-template-masters/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching project template master:', error);
      throw error;
    }
  },

  // Create new project template master
  createProjectTemplateMaster: async (data) => {
    try {
      const response = await api.post('/project-template-masters', data);
      return response.data;
    } catch (error) {
      console.error('Error creating project template master:', error);
      throw error;
    }
  },

  // Update project template master
  updateProjectTemplateMaster: async (id, data) => {
    try {
      const response = await api.put(`/project-template-masters/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating project template master:', error);
      throw error;
    }
  },

  // Delete project template master
  deleteProjectTemplateMaster: async (id) => {
    try {
      const response = await api.delete(`/project-template-masters/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting project template master:', error);
      throw error;
    }
  },

  // Get project template master statistics
  getProjectTemplateMasterStats: async () => {
    try {
      const response = await api.get('/project-template-masters/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching project template master statistics:', error);
      throw error;
    }
  }
};

export default projectTemplateMasterService;
